<template>
  <div id="error-message-modal">
    <b-modal-kariermu
      :is-shown="isOpenModal"
      @change="$emit('update:isOpenModal', $event)"
      hide-footer
      hide-header
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      centered
      size="error-message"
      modal-content-class="modal-content-semi_round"
    >
      <template #content>
        <div class="modal-error-message-container">
          <div class="illustration-container">
            <img :src="illustration" alt="Sekolah.mu" class="illustration">
          </div>
          <div class="header-container">
            <h5 class="font-body-1-new mx-auto title">{{ title }}</h5>
          </div>
          <div class="description-container">
            <p class="font-paragraph-5 description">{{ description }}</p>
          </div>
          <s-button
            variant="'primary'"
            cluster="k"
            class="close-button"
            @click="$emit('onCloseModal')"
            id="error-message-modal-close-button"
          >{{ buttonText }}</s-button>
        </div>
      </template>
    </b-modal-kariermu>
  </div>
</template>
<script>

export default {
  name: 'ErrorMessageModal',
  props: {
    isOpenModal: Boolean,
    illustration: String,
    title: String,
    description: String,
    buttonText: {
      type: String,
      default: 'Mengerti'
    }
  }
}
</script>
<style scoped>
h5, p{
  margin: 0;
}
.modal-error-message-container{
  text-align: center;
  padding: 9px;
}
.illustration{
  width: 192px;
  height: 144px;
  margin-bottom: 16px;
  object-fit: contain;
}

.title{
  color: var(--color-royal-navy-900);
  margin-bottom: 8px;
  max-width: 256px;
}
.description{
  color: var(--color-text-primary);
  margin-bottom: 16px;
}
.close-button{
  width: 100%;
}
</style>
